import en from './en.json'
import nl from './languages/nl.json'

export { nl, en }
